import React from 'react';
import { Link } from 'react-router-dom';
import './FooterMobile.css';

const FooterMobile = () => (
  <div className="footer__mobile">
    <div className="footer__content">
      <p><Link to={{ pathname: '/privacy', state: { prevPath: window.location.pathname } }}>Privacy</Link> © Bureau Veritas Canada (2019) Inc. (legal version).</p>
      <p>Success Through Science® | <Link to={{ pathname: '/terms', state: { prevPath: window.location.pathname } }}>Terms and Conditions</Link></p>
    </div>
  </div>
);

export default FooterMobile;



// WEBPACK FOOTER //
// ./src/components/Footer/FooterMobile/FooterMobile.jsx